<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="账号类型" prop="balanceType">
                <el-select v-model="dataForm.balanceType" placeholder="账号类型">
                    <el-option label="乾坤袋" value="03"></el-option>
                    <el-option label="祝福袋" value="04"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="余额变更" prop="balanceNum">
                <el-input-number v-model="dataForm.changeBalanceAdd" placeholder="变更数量"></el-input-number>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from "lodash/debounce";

    export default {
        name: "memberbalance-add-balance",
        data() {
            return {
                visible: false,
                dataForm: {
                    id: '',
                    memberId: '',
                    balanceType: '',
                    changeBalanceAdd: ''
                }
            }
        },
        computed: {
            dataRule() {
                return {
                    memberId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    changeBalanceAdd: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    balanceType: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init(id) {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    this.dataForm.id=id
                    this.getInfo()
                })
            },
            // 获取信息
            getInfo() {
                this.$http.get(`/ums/memberbalance/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = {
                        ...this.dataForm,
                        ...res.data
                    }
                }).catch(() => {
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function() {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http['put']('/ums/memberbalance/manualChangeBalance/', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>

<style scoped>

</style>